import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  AfterViewInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PaginationService } from "../../helpers/pagination.service";
import { StarConvertService } from "../../helpers/star-convertor.service";
import { MatDateRangePicker } from "@angular/material/datepicker";
import { forkJoin } from "rxjs";
import { ICategories } from "../dashboard/dashboard.model";
import { CommonService } from "../../helpers/common.service";
import { ReviewsService } from "./reviews.service";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { praxisReviewGridColumns, reviewGridColumns } from "./review-columns";
import { IReviewCounts, IReviewGridDataResponse } from "./review.models";
import {
  BookingDetails,
} from "../bookings/booking.models";
import { BookingService } from "../bookings/booking.service";
import { DecimalPipe } from "@angular/common";
import { AuthService } from "../../auth.service";
import { companies } from "../../models/company.model";

@Component({
  selector: "app-reviews",
  templateUrl: "./reviews.component.html",
  styleUrl: "./reviews.component.scss",
  providers: [DecimalPipe], // Provide DecimalPipe here
})
export class ReviewsComponent implements OnInit , AfterViewInit{
  reviewsForm: FormGroup;
  minDate: Date;
  maxDate: Date;
  startDate: any;
  endDate: any;
  @ViewChild("reviewsPicker") reviewsPicker!: MatDateRangePicker<Date>;
  rCategories: ICategories[] = [];
  rStores: ICategories[] = [];
  sortedData: any[] = [];
  resultsLength = 0;
  resultLen = 0;
  totalBookingsCount: number = 0;

  displayedColumns: string[] = [];
  bookingDetails: BookingDetails | null = null; // Initialize as null

  mappedCategories: {
    name: string; // Name from TotalCategories
    value: any; // Value from dataObject using keyMap
  }[];
  mappedStores: {
    name: string; // Name from TotalCategories
    value: any; // Value from dataObject using keyMap
  }[];

  defaultCategory: number[];
  defaultStore: number[];
  bStores: any;
  isAllSelected: boolean;
  selectedStoreIds: number[];
  selectedCategoryIds: number[];

  dataSource = new MatTableDataSource<any>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  pageLimit = 1000;
  currentPageSize: number = 50;
  currentPageIndex: number = 0;
  reviewCountData: IReviewCounts | null;
  reviewGirdData: any[] = [];
  currentOffset: number = 0;
  categories: number[];
  stores: number[];
  isBookingOverview: boolean = false;
  isLoading: boolean;
  companyId: number = 0;
  companyOrgId: number = 0;
  columnName: any;
  sortOrder: string = 'desc';
  showServiceType: boolean = true;
  showStore: boolean = true;
  storeSearchTerm: string = '';
  filteredStores: { storeId: number; name: string }[] = [];
  isStoresLoading: boolean = true;
  isStoreSearchFocused: boolean = false;

  // Hide label when search input is focused
  hidelabel(): void {
    this.isStoreSearchFocused = true;
  }

  // Show label when search input loses focus
  showlabel(): void {
    this.isStoreSearchFocused = false;
  }


  // Filter stores based on search term
  filterStores(event: any): void {
    const searchTerm = event.target.value.toLowerCase();
    this.storeSearchTerm = event.target.value;
    
    // Get currently selected store IDs from form control
    const selectedStoreIds = this.reviewsForm.controls['reviewStore'].value || [];
    
    // Filter stores based on search term
    const filtered = this.rStores.filter((store: any) =>
      store.name.toLowerCase().includes(searchTerm)
    );
    
    // Always include already selected stores in the list (even if they don't match search)
    const selectedStores = this.rStores.filter((store: any) => 
      selectedStoreIds.includes(store.storeId)
    );
    
    // Merge filtered results with selected stores (avoiding duplicates)
    const selectedIds = new Set(filtered.map((s: any) => s.storeId));
    const additionalSelected = selectedStores.filter((s: any) => !selectedIds.has(s.storeId));
    
    this.filteredStores = [...filtered, ...additionalSelected];
  }

  // Clear search and show all stores (preserving selections)
  clearStoreSearch(): void {
    this.storeSearchTerm = '';
    this.filteredStores = [...this.rStores];
  }

  constructor(
    private fb: FormBuilder,
    private commonService: CommonService,
    private starConvertService: StarConvertService,
    private changeDetectorRef: ChangeDetectorRef,
    private paginationService: PaginationService,
    private reviewService: ReviewsService,
    private bookingService: BookingService,
    private decimalPipe: DecimalPipe,
    private authService: AuthService
  ) {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const currentDate = new Date().getDate();
    this.minDate = new Date(2022, 9, 93); // Default October 1st, 2022
    this.maxDate = new Date(currentYear, currentMonth, currentDate);
  }

  ngOnInit(): void {
    this.isStoresLoading = true;
    const companyIdval = localStorage.getItem("companyId");
    this.companyId = companyIdval ? Number.parseInt(companyIdval, 10) : 0;
    const companyOrgval = localStorage.getItem("companyOrg");
    this.companyOrgId = companyOrgval ? Number.parseInt(companyOrgval, 10) : 0;
    const company = companies.find(c => c.id === this.companyId);
    
    this.minDate = company?.minDate || this.minDate;
    this.showServiceType = company?.showServiceType ?? true;
    this.showStore = company?.showStore ?? true;

    this.displayedColumns =
      this.companyId != 4 ? reviewGridColumns : praxisReviewGridColumns;
    this.authService.selectedOrg.subscribe((data) => {});
    if (this.companyId != 4) {
      this.displayedColumns =
        this.companyOrgId === 3
          ? [...reviewGridColumns]
          : reviewGridColumns.filter((col) => col !== "taskId");
    } else {
      this.displayedColumns =
        this.companyOrgId === 3
          ? [...praxisReviewGridColumns]
          : praxisReviewGridColumns.filter((col) => col !== "taskId");
    }

    this.initializeDefualtBookingDates();
    this.createReviewsForm();
    this.loadInitialData();
  }

  filterDates(d: Date | null): boolean {
    return this.commonService.filterDates(d);
  }

  createReviewsForm() {
    this.reviewsForm = this.fb.group({
      startDate: [this.startDate, Validators.required],
      endDate: [this.endDate, Validators.required],
      reviewCategory: [null, Validators.required],
      reviewStore: [null, Validators.required],
      companyId: [this.companyId, Validators.required],
    });
  }

  openDatePicker(): void {
    this.reviewsPicker.open(); // Opens the date picker when the image is clicked
  }

  initializeDefualtBookingDates() {
    this.startDate = new Date(new Date().getFullYear(), 0, 1); // Start: Jan 1st of current year
    // Start: Jan 1st of current year
    this.endDate = new Date(); // End: today
  }

  loadInitialData() {
    forkJoin({
      reviewsCategories: this.commonService.getCategories(this.companyId),
      reviewsStores: this.commonService.getStores(this.companyId),
    }).subscribe(
      ({ reviewsCategories, reviewsStores }) => {
        this.rCategories = Array.isArray(reviewsCategories)
          ? reviewsCategories
          : Object.keys(reviewsCategories);
        this.rStores = Array.isArray(reviewsStores)
          ? reviewsStores
          : Object.keys(reviewsStores);

        this.defaultCategory = this.rCategories.map((cat) => cat.id);
        this.defaultStore = this.rStores.map((store) => store.storeId);
        this.selectedCategoryIds = this.defaultCategory;
        this.selectedStoreIds = this.defaultStore;
        // Handle the booking categories
        if (reviewsCategories && Object.keys(reviewsCategories).length) {
          this.reviewsForm.controls["reviewCategory"].setValue([
            ...this.defaultCategory,
          ]);
          this.isAllSelected = true;
        }

        // Handle the booking stores
        if (reviewsStores && Object.keys(reviewsStores).length) {
          this.reviewsForm.controls["reviewStore"].setValue([
            ...this.defaultStore,
          ]);
          this.isAllSelected = true;
          this.filteredStores = this.rStores;
          this.isStoresLoading = false;
        }

        // Call getAllBookingOverview API with default values after dropdowns are initialized
        this.loadReview(this.defaultCategory, this.defaultStore);
        this.reviewGrid(
          this.pageLimit,
          this.defaultCategory,
          this.defaultStore,
          this.columnName,
          this.sortOrder
        );
      },
      (error) => {
        return;
      }
    );
  }

  //on Date Change
  onDateRangeChange() {
    this.resetData();
    if (
      (this.maxDate !== null && this.minDate !== null) ||
      this.maxDate > this.minDate
    ) {
      if (
        this.minDate.getTime() === this.startDate.getTime() &&
        this.maxDate.getTime() === this.endDate.getTime()
      ) {
        this.loadInitialData();
      } else {
        this.startDate = this.minDate;
        this.endDate = this.maxDate;
        this.loadInitialData();
      }
    }
  }

  resetData() {
    this.currentOffset = 0;
    this.resultsLength = 0;
    this.resultLen = 0;
    this.reviewCountData = null;
    this.reviewGirdData = [];
    this.dataSource.data = [];
    this.sortedData = [];
  }

  getCommonDetails(selectedIds: any, allCategoriesDetails: any) {
    switch (true) {
      // "All" is selected & No categories selected
      case selectedIds.includes(0):
        this.isAllSelected = true;
        if (selectedIds.length === allCategoriesDetails.length - 1) {
          const selectedIdsVal: number[] = selectedIds;
          selectedIds = selectedIdsVal.filter((n) => n !== 0);
        } else {
          selectedIds = [...allCategoriesDetails];
        }
        break;

      // No Categories selected
      case selectedIds.length === allCategoriesDetails.length - 1 &&
        !selectedIds.includes(0) &&
        this.isAllSelected === false:
        this.isAllSelected = true;
        selectedIds = [...allCategoriesDetails];
        break;

      // All categories except "All" are selected
      case selectedIds.length === allCategoriesDetails.length - 1 &&
        !selectedIds.includes(0) &&
        this.isAllSelected === true:
        this.isAllSelected = false;
        selectedIds = [];
        break;
      // Default: Other cases (some categories selected)
      default:
        this.isAllSelected = false;
        break;
    }
    return selectedIds;
  }

  // Handle the selection change
  onCategorySelectionChange(event: any): void {
    const selectedCategoryIds: number[] = event.value;
    this.resetData();
    const selectedCategories = this.getCommonDetails(
      selectedCategoryIds,
      this.defaultCategory
    );
    // Set the selected categories in the form control
    this.reviewsForm.controls["reviewCategory"].setValue(selectedCategories);
    this.loadReview(selectedCategories, this.selectedStoreIds);
    this.reviewGrid(
      this.currentPageSize,
      selectedCategories,
      this.selectedStoreIds,
      this.columnName,
     this.sortOrder
    );
  }

  onStoreSelectionChange(event: any): void {
    const selectedStoreIds: number[] = event.value;
    this.resetData();
    const selectedStores = this.getCommonDetails(
      selectedStoreIds,
      this.defaultStore
    );
    // Set the selected stores in the form control
    this.reviewsForm.controls["reviewStore"].setValue(selectedStores);
    // Make a single call to the API with the selected categories, stores, and status

    this.loadReview(this.selectedCategoryIds, selectedStores);
    this.reviewGrid(
      this.currentPageSize,
      this.selectedCategoryIds,
      selectedStores,
      this.columnName,
      this.sortOrder
    );
  }

  // Compare categories based on their ID
  compareCategories(category1: any, category2: any): boolean {
    return category1 && category2
      ? category1 === category2
      : category1 === category2;
  }

  // Compare stores based on their ID (handles comparison between storeId and store object)
  compareStores(store1: any, store2: any): boolean {
    // store1 is the value from form control (storeId number)
    // store2 is the store object from the list
    if (store1 === null || store1 === undefined || store2 === null || store2 === undefined) {
      return false;
    }
    // Get the actual ID to compare
    const id1 = typeof store1 === 'number' ? store1 : Number.parseInt(store1, 10);
    const id2 = store2.storeId !== undefined ? store2.storeId : (typeof store2 === 'number' ? store2 : Number.parseInt(store2, 10));
    return id1 === id2;
  }

  onPageChange($event: PageEvent) {
    this.currentPageIndex = $event.pageIndex;
    this.currentPageSize = $event.pageSize;
    // Save the pagination state before navigating
    this.paginationService.savePaginationState(
      this.currentPageIndex,
      this.currentPageSize,
      this.resultLen
    );

    const startIndex = this.currentPageIndex * this.currentPageSize;
    let endIndex = startIndex + this.currentPageSize;
    if (endIndex > this.totalBookingsCount) {
      endIndex = this.totalBookingsCount;
    }
    this.paginator._intl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number
    ) => {
      return `${startIndex + 1} - ${endIndex} of ${this.totalBookingsCount}`;
    };

    this.sortedData = this.dataSource.data.slice(startIndex, endIndex);
    this.sortCurrentPageData(); // Apply sorting after fetching data

    if (
      ($event.pageIndex + 1) * $event.pageSize ==
      this.resultLen - $event.pageSize
    ) {
      this.reviewGrid(
        $event.pageSize,
        this.selectedCategoryIds,
        this.selectedStoreIds,
        this.columnName,
        this.sortOrder
      );
    } else {
      // Attach paginator and sorting after data is updated
      this.dataSource.paginator = this.paginator;
    }
    // Check if the user has reached near the end and needs to load more data
    const offsetReached = ($event.pageIndex + 1) * $event.pageSize;
    const isNearEnd = offsetReached >= this.dataSource.data.length;
  }

  loadReview(categories: number[], stores: number[]) {
    this.selectedCategoryIds = categories;
    this.selectedStoreIds = stores;
    const input = {
      CategoryIds: categories ? categories : 0,
      StoreIds: stores ? stores : 0,
      startDate: this.reviewsForm.controls["startDate"].value,
      endDate: this.reviewsForm.controls["endDate"].value,
      companyId: this.companyId,
    };
    if (input.startDate && input.endDate) {
      if (categories.length > 0 && stores.length > 0) {
        this.reviewService
          .getReviewsCounts(input)
          .subscribe((reviews: IReviewCounts) => {
            this.reviewCountData = reviews;
            this.reviewCountData["npsScore"] = this.decimalPipe.transform(
              reviews.npsScore,
              "1.1-2"
            );
            this.reviewCountData["complaints"] = this.decimalPipe.transform(
              reviews.complaints,
              "1.1-2"
            );
            if (this.reviewCountData.reviewsAvg < 0) {
              this.reviewCountData.reviewsAvg = 0;
            } else {
              const starReviews =
                this.starConvertService.convertDecimalNumberToStars(
                  reviews.reviewsAvg
                );
              this.reviewCountData["starRating"] = starReviews;
            }
            this.reviewCountData["reviewsAvg"] = this.decimalPipe.transform(
              reviews.reviewsAvg,
              "1.1-2"
            );
            this.changeDetectorRef.detectChanges();
          });
      }
    }
  }

  reviewGrid(pageSize: number, categories: number[], stores: number[], columnName?:string, sortOrder?: string) {
    this.categories = categories;
    this.stores = stores;
    const offset = this.dataSource.data.length; // Calculate offset based on current data length
    this.dataSource.sort = this.sort;
    this.selectedCategoryIds = categories;
    this.selectedStoreIds = stores;
    const input = {
      CategoryIds: categories ? categories : [],
      StoreIds: stores ? stores : [],
      startDate: this.reviewsForm.controls["startDate"].value,
      endDate: this.reviewsForm.controls["endDate"].value,
      pageSize: this.pageLimit,
      pageOffset: offset,
      companyId: this.companyId,
       columnName: columnName
        ? this.capitalizeFirstLetter(columnName)
        : "Id",
      sortOrder: this.sortOrder,
    };
    if (input.startDate > 0 && input.endDate > 0) {
      if (categories.length > 0 && stores.length > 0) {
        this.reviewService
          .getReviewGridData(input)
          .subscribe((gridData: IReviewGridDataResponse) => {
            this.resultsLength = gridData.value.reviewsCount;
            this.totalBookingsCount = gridData.value.reviewsCount;
            this.reviewGirdData = gridData.value.reviewsOverview.map((data, index) => {
              const startingIndex = index + offset;
              let starRating = "";
              let ratingMessage = "";
              if (data.rating < 0) {
                ratingMessage = "-";
              } else {
                starRating =
                  this.starConvertService.convertDecimalNumberToStars(
                    data.rating
                  );
              }
              return {
                ...data,
                starRating,
                ratingMessage,
                number: startingIndex + 1,
              };
            });
            // Append new data to the existing data
            this.dataSource.data = [
              ...this.dataSource.data,
              ...this.reviewGirdData,
            ];
            this.resultLen = this.resultLen + this.reviewGirdData.length; // Update the total length of the data

            // Attach paginator and sorting after data is updated
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;

            const startIndex = this.currentPageIndex * this.currentPageSize;
            const endIndex = startIndex + this.currentPageSize;

            this.sortedData = this.dataSource.data.slice(startIndex, endIndex);
            this.sortCurrentPageData(); // Apply sorting after fetching data
          });
      }
    }
  }

   capitalizeFirstLetter(str: string): string {
    if (!str) {
      return str;
    }
    // This handles simple camelCase to TitleCase (e.g., 'serviceType' -> 'ServiceType')
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

   handleSortChange(event: Sort) {
      this.dataSource.data = [];
      this.resultLen = 0;
      this.sortOrder = event.direction; // Capture the sort direction
      this.columnName = event.active; // Capture the sorted column name
      // 'sortState.active' will give you the `matColumnDef` name of the sorted column
      // 'sortState.direction' will give you the sort direction ('asc', 'desc', or '')
      // You can use these values for various purposes, for example:
      // 1. If you're doing server-side sorting:
      //    Call your API with sortState.active and sortState.direction to get sorted data.
      // 2. For custom client-side sorting:
      //    Implement your own sorting logic based on these values (though MatTableDataSource
      //    often handles basic client-side sorting automatically once `dataSource.sort` is set).
      if (event.active && event.direction) {
        this.reviewGrid(
          this.currentOffset,
          this.selectedCategoryIds,
          this.selectedStoreIds,
          event.active,
          event.direction,
        );
      } 
      else {
        this.reviewGrid(
          this.currentOffset,
          this.selectedCategoryIds,
          this.selectedStoreIds,
          event.active,
          event.direction,
        );
        //TODO remove after testing
        // this._snackBar.open("Sorting is been cleared", "Close", {
        //   duration: 3000,
        //   horizontalPosition: "center",
        //   verticalPosition: "top",
        // });
      }
    }

  // Apply sorting logic to current page's data
  sortCurrentPageData() {
    if (this.sort.active && this.sort.direction !== "") {
      const startIndex = this.currentPageIndex * this.currentPageSize;
      const endIndex = startIndex + this.currentPageSize;
      // Slice data for current page and apply sorting
      // const currentPageData = this.dataSource.data.slice(startIndex, endIndex);
      // this.sortedData = currentPageData.sort((a, b) => {
      //   const isAsc = this.sort.direction === "asc";
      //   switch (this.sort.active) {
      //     case "number":
      //       return this.sorting(a.number, b.number, isAsc);
      //     case "taskId":
      //       return this.sorting(a.taskId, b.taskId, isAsc);
      //     case "serviceType":
      //       return this.sorting(a.serviceType, b.serviceType, isAsc);
      //     case "executionDate":
      //       return this.sortingDate(this.parseDate(a.executionDate), this.parseDate(b.executionDate), isAsc);
      //     case "rating":
      //       return this.sorting(a.rating, b.rating, isAsc);
      //     case "review":
      //       return this.sorting(a.review, b.review, isAsc);
      //     case "receiveDate":
      //       return this.sortingDate(
      //         this.parseDate(a.receiveDate),
      //         this.parseDate(b.receiveDate),
      //         isAsc
      //       );
      //     default:
      //       return 0;
      //   }
      // });
    }
  }

    sortingDate(
    a: number | string | Date,
    b: number | string | Date,
    isAsc: boolean
  ) {
    // Convert string dates to Date objects if they are not already
    const dateA = new Date(a);
    const dateB = new Date(b);

    // Compare the dates
    return (dateA.getTime() - dateB.getTime()) * (isAsc ? 1 : -1);
  }

   parseDate(dateString: string): Date {
    const [day, month, year] = dateString.split("-").map(Number); // Split the string and convert to numbers
    return new Date(year, month - 1, day); // Create a Date object (month is zero-based)
  }

  // Custom comparison function
  sorting(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  // Apply filter for searching (optional)
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    // After applying filter, sort the visible data
    this.sortCurrentPageData();
  }

  ngAfterViewInit() {
    // Ensure sorting works by listening to sort changes
    this.sort.sortChange.subscribe(() => {
      this.sortCurrentPageData();
    });
  }

  isBookingsData(event: any) {
    this.isBookingOverview = !this.isBookingOverview;
    // Restore pagination state if returning to the list view
    if (!this.isBookingOverview) {
      const savedState = this.paginationService.getPaginationState();

      if (savedState && this.paginator) {
        this.currentPageIndex = savedState.pageIndex;
        this.currentPageSize = savedState.pageSize;
        this.resultLen = savedState.resultsLength;

        this.paginator.pageIndex = this.currentPageIndex;
        this.paginator.pageSize = this.currentPageSize;

        // this.reviewGrid(this.currentPageSize, this.selectedCategoryIds, this.selectedStoreIds);
      }
    }
  }

  overview(taksid: number): any {
    // Save the current page state before navigation
    this.paginationService.savePaginationState(
      this.currentPageIndex,
      this.currentPageSize,
      this.resultLen
    );

    this.isLoading = true;
    this.bookingService
      .getBookingDetailsByTask(taksid, this.companyId)
      .subscribe(
        (details: BookingDetails) => {
          this.bookingDetails = details;
          this.bookingService.bookingOverviewDetails.next(details);
          this.isBookingOverview = true;
          this.isLoading = false;
          this.changeDetectorRef.detectChanges();
        },
        (error) => {
          // return;
          console.error("Error fetching booking details:", error);
        }
      );
  }
}
